import { c as _c } from "react/compiler-runtime";
import { focusManager } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useEventCallback } from 'usehooks-ts';

/**
 * Runs `callback` when the user returns to the tab, using react-query's focus
 * tracking — the same signal behind `refetchOnWindowFocus`.
 */
const useOnReturnToTab = callback => {
  const $ = _c(3);
  const stableCallback = useEventCallback(callback);
  let t0;
  let t1;
  if ($[0] !== stableCallback) {
    t0 = () => focusManager.subscribe(isFocused => {
      if (isFocused) {
        stableCallback();
      }
    });
    t1 = [stableCallback];
    $[0] = stableCallback;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
};
export default useOnReturnToTab;